import React from 'react';
import { getRbskData } from '../../../../services/adminService';
import RbskDataTable from './RbskDataTable';
import RbskVisualInsights from './RbskVisualInsights';
import DataPoints from '../DataPoints';
import { exportToCSV } from '../../../../utils/exportUtils';

const calculateTotalsFn = (chartRecords) => {
    let non = 0, mild = 0, mod = 0, sev = 0;
    chartRecords.forEach((r) => {
        non += Number(r.ch_6to18m_normal || 0);
        mild += Number(r.ch_6to18m_mild || 0);
        mod += Number(r.ch_6to18m_moderate || 0);
        sev += Number(r.ch_6to18m_severe || 0);
    });
    return { non, mild, mod, sev };
};

const exportCSVFn = (localData, sourceName) => {
    const headers = [
        "ID", "Reporting Date", "State Name", "District Name", "Health Block",
        "Children (6 Months -18 Years) Non Anaemic", "Children (6 Months -18 Years) Mild",
        "Children (6 Months -18 Years) Moderate", "Children (6 Months -18 Years) Severe"
    ];

    const fields = [
        "id", "report_date", "state_name", "district_name", "block_name",
        "ch_6to18m_normal", "ch_6to18m_mild", "ch_6to18m_moderate", "ch_6to18m_severe"
    ];

    exportToCSV(localData, sourceName, headers, fields);
};

const RbskDataPoints = ({ onTotalsCalculated }) => {

    return (
        <DataPoints
            sourceName="RBSK"
            fetchDataFn={getRbskData}
            onTotalsCalculated={onTotalsCalculated}
            renderVisuals={(chartData, loading) => (
                <RbskVisualInsights chartData={chartData} loading={loading} />
            )}
            renderTable={(records, loading, currentPage, setCurrentPage, totalCount, totalPages, rowsPerPage) => (
                <RbskDataTable
                    records={records} loading={loading}
                    currentPage={currentPage} setCurrentPage={setCurrentPage}
                    totalCount={totalCount} totalPages={totalPages} rowsPerPage={rowsPerPage}
                />
            )}
            exportCSVFn={exportCSVFn}
            calculateTotalsFn={calculateTotalsFn}
        />
    );
};

export default RbskDataPoints;
